import React from 'react';
import { Marker, Polyline } from 'google-maps-react';

import { getIconFromServiceVehicle, getPinIconWithColor } from './MarkerIcons';
import { pickColor } from '../helper';

const noop = () => {};

// eslint-disable-next-line import/prefer-default-export
export function locationToMarker({
  client_location_id,
  trailer_lat,
  trailer_lng,
  long_name,
  default_mechanical_service_vehicle_id,
  serviceVehicleId,
  numBookings,
  onClick = noop,
  overrideColor = null,
}) {
  const serviceVehicleId2 =
    serviceVehicleId || default_mechanical_service_vehicle_id;
  const title = numBookings > 0 ? `${long_name} : ${numBookings}` : long_name;

  const icon = overrideColor
    ? getPinIconWithColor(overrideColor)
    : getIconFromServiceVehicle(serviceVehicleId2, numBookings);

  return (
    <Marker
      onClick={onClick}
      key={`ClientLocation-${client_location_id}`}
      position={{ lat: trailer_lat, lng: trailer_lng }}
      name={title}
      title={title}
      icon={icon}
    />
  );
}

export function locationToDraggableMarker({ lat, lng, title, onMarkerDrag }) {
  return (
    <Marker
      key={title}
      name={title}
      title={title}
      position={{ lat, lng }}
      draggable
      onDragend={onMarkerDrag}
    />
  );
}

export function vehicleToMarker({ name, deviceId, latitude, longitude }) {
  const color = pickColor(name);
  return (
    <Marker
      key={`Vehicle-${deviceId}`}
      position={{ lat: latitude, lng: longitude }}
      name={name}
      title={name}
      icon={getPinIconWithColor(color)}
    />
  );
}

function createPolyline(deviceId, coords, color = '#0000FF') {
  const path = coords.map(({ latitude, longitude }) => ({
    lat: latitude,
    lng: longitude,
  }));

  return (
    <Polyline
      key={`Polyline-${deviceId}`}
      path={path}
      strokeColor={color}
      strokeOpacity={0.8}
      strokeWeight={10}
    />
  );
}

export function coordsToPolylines(coords) {
  // First, group by deviceId
  const deviceIdToCoords = {};
  coords.forEach((coord) => {
    deviceIdToCoords[coord.deviceId] = deviceIdToCoords[coord.deviceId] || [];
    deviceIdToCoords[coord.deviceId].push(coord);
  });

  // Then, form a polyline for each deviceId
  const deviceIds = Object.keys(deviceIdToCoords);
  return deviceIds.map((deviceId) => {
    const deviceCoords = deviceIdToCoords[deviceId];
    return createPolyline(deviceId, deviceCoords);
  });
}

export function locationsToPolylines(
  fromLocation,
  locations,
  color = '#0000FF',
) {
  const fromLocConverted = {
    lat: fromLocation.trailer_lat,
    lng: fromLocation.trailer_lng,
  };

  return locations.map(({ trailer_lat, trailer_lng, id }) => {
    const path = [fromLocConverted, { lat: trailer_lat, lng: trailer_lng }];

    return (
      <Polyline
        key={`Polyline-${fromLocation.id}-${id}`}
        path={path}
        strokeColor={color}
        strokeOpacity={0.5}
        strokeWeight={4}
      />
    );
  });
}
